__turbopack_context__.v({
  "container": "ProductQuantitySelector-module-scss-module__9HRxvW__container",
  "dropdown": "ProductQuantitySelector-module-scss-module__9HRxvW__dropdown",
  "label": "ProductQuantitySelector-module-scss-module__9HRxvW__label",
  "minQuantityMessage": "ProductQuantitySelector-module-scss-module__9HRxvW__minQuantityMessage",
});
